import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { senaGetMyInfo, senaUpdateMyInfo } from '../../api/senaApi';
import './SenaAuth.css';

const PUUID_PATTERN = /^[A-F0-9]{32}$/;

export default function SenaProfile() {
  const navigate = useNavigate();
  const [loginId, setLoginId] = useState('');
  const [userRole, setUserRole] = useState('');
  const [userName, setUserName] = useState('');
  const [puuid, setPuuid] = useState('');
  const [passWd, setPassWd] = useState('');
  const [passWdConfirm, setPassWdConfirm] = useState('');
  const [error, setError] = useState('');
  const [info, setInfo] = useState('');
  const [loading, setLoading] = useState(false);
  const [fetching, setFetching] = useState(true);

  useEffect(() => {
    senaGetMyInfo()
      .then(r => {
        const d = r.data || {};
        setLoginId(d.loginId || '');
        setUserRole(d.userRole || '');
        setUserName(d.userName || '');
        setPuuid(d.puuid || '');
      })
      .catch(() => setError('내 정보를 불러올 수 없습니다.'))
      .finally(() => setFetching(false));
  }, []);

  const handlePuuidChange = (e) => {
    // 대문자 + 0-9만, 공백 제거, 최대 32자
    const v = e.target.value.toUpperCase().replace(/[^A-F0-9]/g, '').slice(0, 32);
    setPuuid(v);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setInfo('');

    if (!userName.trim()) {
      setError('닉네임을 입력해주세요.'); return;
    }
    if (puuid && !PUUID_PATTERN.test(puuid)) {
      setError(`PUUID는 32자의 대문자/숫자 조합이어야 합니다. (현재 ${puuid.length}자)`); return;
    }
    if (passWd || passWdConfirm) {
      if (passWd !== passWdConfirm) { setError('비밀번호가 일치하지 않습니다.'); return; }
      if (passWd.length < 4) { setError('비밀번호는 4자 이상이어야 합니다.'); return; }
    }

    setLoading(true);
    try {
      await senaUpdateMyInfo({
        userName: userName.trim(),
        puuid: puuid || '',
        passWd: passWd || '',
      });
      // 로컬 반영
      localStorage.setItem('userName', userName.trim());
      setInfo('저장되었습니다.');
      setPassWd('');
      setPassWdConfirm('');
    } catch (err) {
      const msg = err?.response?.data || '저장에 실패했습니다.';
      setError(typeof msg === 'string' ? msg : JSON.stringify(msg));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="sena-page">
      <header className="sena-header">
        <button className="siege-back-btn" onClick={() => navigate('/sena')}>← 메인으로</button>
        <h1 className="sena-header-guild">내 정보 수정</h1>
      </header>

      <div className="sena-auth-container">
        <div className="sena-auth-card">
          {fetching ? (
            <p className="sena-auth-sub">불러오는 중...</p>
          ) : (
            <form onSubmit={handleSubmit} className="sena-auth-form">
              <div className="sena-auth-field">
                <label>아이디</label>
                <input type="text" value={loginId} disabled />
              </div>
              <div className="sena-auth-field">
                <label>등급</label>
                <input type="text" value={userRole} disabled />
              </div>
              <div className="sena-auth-field">
                <label>닉네임</label>
                <input type="text" value={userName} onChange={e => setUserName(e.target.value)}
                  placeholder="세나 닉네임" maxLength={30} />
              </div>
              <div className="sena-auth-field">
                <label>PUUID (넷마블 32자)</label>
                <input type="text" value={puuid} onChange={handlePuuidChange}
                  placeholder="예: F605B10AAC5D493287CB02A2C9705AAE" maxLength={32}
                  style={{ fontFamily: 'monospace', letterSpacing: 1 }} />
                <small style={{ color: puuid && !PUUID_PATTERN.test(puuid) ? '#c04040' : '#8a6a50', fontSize: 12, marginTop: 4, display: 'block' }}>
                  {puuid.length === 0
                    ? '비워두면 저장하지 않습니다.'
                    : puuid.length === 32
                      ? '✓ 형식이 올바릅니다.'
                      : `현재 ${puuid.length}/32자 — 32자를 채워주세요.`}
                </small>
              </div>

              <hr style={{ border: 'none', borderTop: '1px dashed #f0d6c0', margin: '8px 0' }} />
              <p style={{ fontSize: 12, color: '#8a6a50', margin: 0 }}>
                비밀번호 변경 시에만 아래 두 필드를 입력하세요.
              </p>

              <div className="sena-auth-field">
                <label>새 비밀번호</label>
                <input type="password" value={passWd} onChange={e => setPassWd(e.target.value)}
                  placeholder="변경 시에만 입력" autoComplete="new-password" />
              </div>
              <div className="sena-auth-field">
                <label>새 비밀번호 확인</label>
                <input type="password" value={passWdConfirm} onChange={e => setPassWdConfirm(e.target.value)}
                  placeholder="변경 시에만 입력" autoComplete="new-password" />
              </div>

              {error && <p className="sena-auth-error">{error}</p>}
              {info && <p className="sena-auth-error" style={{ color: '#2a8a4a' }}>{info}</p>}

              <button type="submit" className="sena-auth-btn" disabled={loading}>
                {loading ? '저장 중...' : '저장'}
              </button>
            </form>
          )}
        </div>
      </div>
    </div>
  );
}
